import { BREAKPOINT } from '@spartacus/storefront';
import MobileDetect from 'mobile-detect';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

export type BrowserName = 'chrome' | 'safari' | 'edge' | 'firefox' | 'opera';

export class UserAgent {
  private userAgent: string;
  private cache: Map<string, any>;
  private _mobileDetect$: Observable<MobileDetect>;

  private get mobileDetect$(): Observable<MobileDetect> {
    if (!this._mobileDetect$) {
      const subject = new ReplaySubject<MobileDetect>(1);
      this._mobileDetect$ = subject;

      // При lazy лоадинге на сервере конструктором сам импортируемый модуль,
      // а при инициализации на клиенте лежит в default
      import('mobile-detect').then((md) => {
        const constructor = typeof md === 'function' ? md : md.default;
        subject.next(new constructor(this.userAgent));
      });
    }

    return this._mobileDetect$;
  }

  constructor(userAgent: string = '') {
    this.userAgent = userAgent;
    this.cache = new Map();

    if (!this.userAgent) {
      console.error('Пустой юзер-агент');
    }
  }

  get value(): string {
    return this.userAgent;
  }

  get isBot(): boolean {
    return this.withCache('isBot', () => {
      const regExp = /google\.com|yandex\.com\/bots|googlebot|YandexMobileBot/gim;

      return regExp.test(this.userAgent);
    });
  }

  get browserName(): BrowserName | null {
    return this.withCache('browserName', () => {
      if (this.userAgent.match(/edg/i)) {
        return 'edge';
      }
      if (this.userAgent.match(/opr\//i)) {
        return 'opera';
      }
      if (this.userAgent.match(/chrome|chromium|crios/i)) {
        return 'chrome';
      }
      if (this.userAgent.match(/firefox|fxios/i)) {
        return 'firefox';
      }
      if (this.userAgent.match(/safari/i)) {
        return 'safari';
      }

      return null;
    });
  }

  get breakpoint$(): Observable<BREAKPOINT> {
    return this.mobileDetect$.pipe(
      map((mobileDetect: MobileDetect) => {
        if (mobileDetect.phone() || mobileDetect.os() === 'AndroidOS') {
          return BREAKPOINT.xxs;
        }

        if (mobileDetect.tablet()) {
          return BREAKPOINT.md;
        }

        return BREAKPOINT.lg;
      }),
    );
  }

  get os$(): Observable<string> {
    return this.mobileDetect$.pipe(map((mobileDetect) => mobileDetect.os()));
  }

  private withCache<T>(key: string, f: () => T): T {
    if (!this.cache.has(key)) {
      this.cache.set(key, f());
    }

    return this.cache.get(key);
  }
}
